import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignMagazineHotelArticleI18nEditContainer } from "@/components/features/design/magazine/edit/about-hotel/i18n";
import { DesignMagazinePlanArticleI18nEdit } from "@/components/features/design/magazine/edit/plan/i18n";
import { DesignMagazineRoomArticleI18nEdit } from "@/components/features/design/magazine/edit/room/i18n";

import { useGetMagazinePageParams } from "./hooks/use-get-params";

export const DesignMagazineEditI18nPage = () => {
	const { hotelID, magazineResourceID, magazineResourceType, langCode } = useGetMagazinePageParams();

	return (
		<PageMeta title="マガジンの編集" url={generatePath(PATHS.HOTEL.TOP, { hotelID })}>
			{magazineResourceType === "Plan" && (
				<DesignMagazinePlanArticleI18nEdit hotelID={hotelID} planID={magazineResourceID} langCode={langCode} />
			)}
			{magazineResourceType === "AboutHotel" && (
				<DesignMagazineHotelArticleI18nEditContainer hotelID={hotelID} langCode={langCode} />
			)}
			{magazineResourceType === "Room" && (
				<DesignMagazineRoomArticleI18nEdit hotelID={hotelID} roomID={magazineResourceID} langCode={langCode} />
			)}
		</PageMeta>
	);
};

DesignMagazineEditI18nPage.displayName = "DesignMagazineEditI18nPage";
